import React from 'react';
import Header from './GoodDescComp/Header';
import Table from './GoodDescComp/Table';
import Photo from './GoodDescComp/Photo';
import Text from './GoodDescComp/Text';

const GoodDesc = (props) => {
    function SetEdit(){
        let header = []
        props.textFields.forEach((value , index)=>{
            switch(value.type){
                case 'headers':
                    header.push(<Header key={index} title={value.type} color={value.color} size={value.size}  weight={value.weight} data={value.data}/>)
                    break; 
                case 'text':
                    header.push(<Text key={index} title={value.type} color={value.color}  background={value.bgcolor}  weight={value.weight}  data={value.data}/>)
                    break;
                case 'photo':
                    header.push(<Photo key={index} title={value.type} color={value.color}  background={value.bgcolor} data={value.data} caption={value.caption} capcolor={value.capcolor} />)
                    break;
                case 'table':
                    header.push(<Table key={index} title={value.type} color={value.color}  background={value.bgcolor} data={value.data} value={value.val}/>)
                    break;
                default:
                break;
            }
        })
        return header;
    }
    return (
        <React.Fragment>
            {SetEdit()}
        </React.Fragment>
    )
}
export default GoodDesc;